/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/qaSelectionFollowArea.ts
 * FILE_ID: JOBHUB-QA-SELECTION-FOLLOW-001
 * PURPOSE: Map a ticked checklist or check back to the area that owns it.
 */
import type { QaAreaExecution } from '../../qa/qaApi'
// Reused from: packages/job-hub/src/jobs/qa/qaApiHelpers.ts (checklistGroups)
import { checklistGroups } from '../../qa/qaApiHelpers'

export function areaOfChecklist(
  executions: readonly QaAreaExecution[],
  checklistId: string,
): string | null {
  for (const area of executions) {
    if (checklistGroups(area).some((group) => group.checklist.id === checklistId)) return area.id
  }
  return null
}

export function areaOfCheck(
  executions: readonly QaAreaExecution[],
  checkId: string,
): { areaId: string; checklistId: string } | null {
  for (const area of executions) {
    for (const group of checklistGroups(area)) {
      if (group.items.some((item) => item.id === checkId)) {
        return { areaId: area.id, checklistId: group.checklist.id }
      }
    }
  }
  return null
}

export function childrenOfChecklist(
  executions: readonly QaAreaExecution[],
  checklistId: string,
): { areaId: string; itemIds: string[] } | null {
  for (const area of executions) {
    for (const group of checklistGroups(area)) {
      if (group.checklist.id === checklistId) {
        return { areaId: area.id, itemIds: group.items.map((item) => item.id) }
      }
    }
  }
  return null
}

export function childrenOfArea(
  executions: readonly QaAreaExecution[],
  areaId: string,
): { checklistIds: string[]; itemIds: string[] } | null {
  for (const area of executions) {
    if (area.id !== areaId) continue
    const groups = checklistGroups(area)
    return {
      checklistIds: groups.map((group) => group.checklist.id),
      itemIds: groups.flatMap((group) => group.items.map((item) => item.id)),
    }
  }
  return null
}
